module.exports = __webpack_public_path__ + "static/card.c40cf4aa.png";